import { createReduxAsyncThunk } from 'shared/utils';

import dataSources from 'dataSources';

import { STATIONS_STATE } from '../../constants';

import { FavouriteStation } from '../../types';

export const addFavouriteStations = createReduxAsyncThunk<
  { favouriteStations: FavouriteStation[] },
  FavouriteStation['stationCode'][]
>(
  `${STATIONS_STATE}/addFavouriteStation`,
  async (stationCodes) => {
    return await dataSources.stationsWithPrices.addFavouriteStations(stationCodes);
  }
);
